
import { IInstallEvent } from "@/modules/dashboard/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const DashboardModule = namespace("DashboardModule");

@Component
export default class PwaPrompt extends Vue {
  display = false;

  @DashboardModule.State
  installEvent!: IInstallEvent | null;

  @DashboardModule.Mutation
  setInstallEvent!: (event: IInstallEvent | null) => void;

  @Watch("installEvent")
  displayPrompt() {
    if (this.installEvent) this.display = true;
  }

  async install() {
    this.installEvent!.prompt();
    await this.installEvent!.userChoice;
    this.display = false;
  }

  close() {
    this.setInstallEvent(null);
    this.display = false;
  }

  mounted() {
    this.displayPrompt();
  }
}
